// extracted by mini-css-extract-plugin
module.exports = {"content_container":"RegistrationScreen_content_container__169pw","main":"RegistrationScreen_main__ExhFS"};